import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GetClientsParameters } from 'api/types';

export const DEFAULT_VALUES: GetClientsParameters = {
  limit: 25,
  offset: 0,
  sortBy: 'name',
  direction: 'asc'
};

/**
 * Service that distributes filters (which results in GetClients params) for the Clients page.
 */
@Injectable({
  providedIn: 'root'
})
export class ClientsFiltersService {
  // Init with empty values; the filter component will populate them later
  private readonly params = new BehaviorSubject<GetClientsParameters>(DEFAULT_VALUES)

  // eslint-disable-next-line @typescript-eslint/member-ordering, no-invalid-this
  public params$ = this.params.asObservable()

  public constructor() {
    // Prevent handler from being called in the component's context
    this.updateParams = this.updateParams.bind(this);
  }

  public updateParams(changes: Partial<GetClientsParameters>): void {
    this.params.next({ ...this.params.getValue(), offset: 0, ...changes });
  }
}
